<template>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="500px" @close="reset">
      <div slot="content">
        <w-common-obj-list ref="commonObjList" type="physical" selected-managetype-id="SMS">
          <template slot="title">
            <div class="title-h4 mr-r10">
              관리 대상 정보
            </div>
            <el-row v-show="isLogGroup">
              <el-checkbox v-model="isGroupApplyFilterInfo">Log Filter 정보 그룹적용</el-checkbox>
            </el-row>
          </template>
        </w-common-obj-list>
        <el-row class="title-bar">
          <div class="title-h4">{{contentTitle}}</div>
        </el-row>
        <el-row class="mr-b10">
          <el-table-wrapper border :data="tableData" :columns="tableColumn" :pagination="false"
            :show-custom-header="false" header-align="center">
            <template slot-scope="scope" slot="applogType-slot">
              <span v-if="scope.row.applogType === 'T'">텍스트</span>
              <span v-else-if="scope.row.applogType === 'B'">바이너리</span>
              <span v-else>MySql Load</span>
            </template>
            <template slot-scope="scope" slot="patternFlag-slot">
              <span v-if="scope.row.patternFlag === 'N'">고정형</span>
              <span v-else>패턴형</span>
            </template>
            <template slot-scope="scope" slot="label-slot">
              <span v-if="scope.row.label === 'DF'">DB.File</span>
              <span v-else-if="scope.row.label === 'D'">DB</span>
              <span v-else-if="scope.row.label === 'F'">File</span>
              <span v-else>NONE</span>
            </template>
            <template slot-scope="scope" slot="applogFileAttrib-slot">
              <span v-if="scope.row.applogFileAttrib === 'F'">파일</span>
              <span v-else>디렉토리</span>
            </template>
            <template slot-scope="scope" slot="applogRawDelInteval-slot">
              <span v-if="scope.row.applogRawDelInteval === 'D'">일간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'W'">주간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'M'">월간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'Y'">연간</span>
              <span v-else>-</span>
            </template>
            <template slot-scope="scope" slot="applogRealtimeSendFlag-slot">
              <span v-if="scope.row.applogRealtimeSendFlag === '1'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
            <template slot-scope="scope" slot="applogRawDelFlag-slot">
              <span v-if="scope.row.applogRawDelFlag === '1'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
          </el-table-wrapper>
        </el-row>
      </div>
      <div slot="footer">
        <el-button @click="settingApplogGroup" type="solid" size="large">저장</el-button>
        <el-button @click="close" size="large">취소</el-button>
      </div>
    </w-sliding-popup>
</template>

<script>
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import WCommonObjList from '@/components/table/CommonObjList';
import LmsApplogAPI from '@/api/settings/log/lms-applog-setting';

import { stringify } from 'querystring';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';

export default {
  name: 'WAppLogTreeListPopup',
  components: {
    WSettingSlidingPopup,
    WCommonObjList,
  },
  props: {
    checkList: {
      type: Array,
    },
    isLogGroup: {
      type: Boolean,
    },
    selectPhysicalNode: {
      type: Object,
    },
  },
  data() {
    return {
      serverId: [],
      isGroupApplyFilterInfo: false,
      tableData: null,
      title: '로그 그룹 적용',
      contentTitle: '자원 구분',
      logTableColumn: [
        {
          prop: 'applogId',
          label: '로그아이디',
        },
        {
          prop: 'applogType',
          label: '로그타입',
          scopedSlot: 'applogType-slot',
        },
        {
          prop: 'applogDir',
          label: '로그경로',
        },
        { prop: 'patternFlag',
          label: '타입',
          scopedSlot: 'patternFlag-slot',
        },
        { prop: 'applogFile',
          label: '로그 파일명',
        },
        { prop: 'label',
          label: '로그 저장',
          scopedSlot: 'label-slot',
        },
        { prop: 'applogFileAttrib',
          label: '파일/디렉토리',
          scopedSlot: 'applogFileAttrib-slot',
        },
      ],
      filterTableColumn: [
        { prop: 'applogId', label: '로그명' },
        { prop: 'applogFilterId', label: '정책 명' },
        { prop: 'filterCondition', label: '정책 조건' },
        { prop: 'exceptFilterCondition', label: '예외 정책' },
      ],
      tableColumn: null,
      tempList: [],
    };
  },
  methods: {
    /**
     * 로그 그룹 저장
     * @author leesy918
     * @return {[type]} [description]
     */
    settingApplogGroup() {
      if (this.isLogGroup) {
        this.saveApplogGroup();
      } else {
        this.saveApplogFilterGroup();
      }
    },
    saveApplogGroup() {
      let queryString = stringify({
        serverId: this.selectPhysicalNode.serverId,
        isGroupApplyFilterInfo: this.isGroupApplyFilterInfo,
      });
      if (this.isGroupApplyFilterInfo) {
        this.tableData.forEach((item) => {
          queryString += `&applogIds=${item.applogId}`;
        });
      } else {
        queryString += '&applogIds=';
      }
      const queryArray = [];
      const serverList = this.$refs.commonObjList.getSelectedObjList();
      serverList.forEach((item) => {
        this.tableData.forEach((logData) => {
          const data = cloneDeep(logData);
          if (item.serverId !== data.serverId) {
            data.logInfo.logId = null;
            data.logInfo.objId = item.objId;
            data.serverId = item.serverId;
          }
          queryArray.push(data);
        });
      });
      const params = queryArray;
      if (isEmpty(params)) {
        this.$message(msgUtil.getRequireInfoMsg(msgUtil.action.SELECT, '서버'));
      } else {
        LmsApplogAPI.addApploggroup(queryString, params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '로그 그룹', true));
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '로그 그룹', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '로그 그룹', false));
          throw new Error(e);
        });
      }
    },
    saveApplogFilterGroup() {
      const queryString = stringify({
        serverId: this.selectPhysicalNode.serverId,
      });
      const queryArray = [];
      const serverList = this.$refs.commonObjList.getSelectedObjList();
      serverList.forEach((item) => {
        this.tableData.forEach((filterData) => {
          const data = cloneDeep(filterData);
          data.applogRawDelFlag = true;
          data.applogRealtimeSendFlag = true;
          data.serverId = item.serverId;
          data.objId = item.objId;
          queryArray.push(data);
        });
      });
      const params = queryArray;
      if (isEmpty(params)) {
        this.$message(msgUtil.getRequireInfoMsg(msgUtil.action.SELECT, '서버'));
      } else {
        LmsApplogAPI.saveApplogFilterGroup(queryString, params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '필터 그룹', true));
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '필터 그룹', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '필터 그룹', false));
          throw new Error(e);
        });
      }
    },
    onClickNode(data) {
      this.selectPhysicalNode = data;
    },
    reset() {
      this.$refs.commonObjList.initData();
      this.isGroupApplyFilterInfo = false;
    },
    open() {
      this.tempList = [];
      this.title = (this.isLogGroup) ? '로그 그룹 적용' : '정책 그룹 적용';
      this.tableColumn = (this.isLogGroup) ? this.logTableColumn : this.filterTableColumn;
      this.$refs.slidingPopup.visible = true;
      this.tableData = Object.values(this.checkList);
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/popup/AppLogTreeListPopup.vue